import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import MyProfile from './MyProfile';
import { Tab, Tabs } from '@mui/material';
import EditProfile from './EditProfile';
import ChangePassword from './ChangePassword';

function CustomTabPanel(props: any) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box p={3}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

const MyProfileTab = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue)
  };

  return (
    <Box pt={2} sx={{backgroundColor: '#f2f5fc', height: '91vh'}}>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={value} onChange={handleChange} aria-label="basic tabs example" centered>
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Profile" {...a11yProps(0)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Edit Profile" {...a11yProps(1)} />
          <Tab sx={{"&.Mui-selected": {color: "black"}}} label="Change Password" {...a11yProps(2)} />
        </Tabs>
      </Box>

      <CustomTabPanel value={value} index={0}>
        <MyProfile />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={1}>
        <EditProfile />
      </CustomTabPanel>

      <CustomTabPanel value={value} index={2}>
        <ChangePassword />
      </CustomTabPanel>
    </Box>
  );
}

export default MyProfileTab;
